module.exports = __webpack_public_path__ + "static/media/XtadiumContentPosterXXLNoImage.ab9652ee.png";